import * as React from "react";
import MainLayout from "@/components/template/dashboard-layout";

export default function NotFoundPage() {
  return (
    <MainLayout>
      <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
        <div className="mb-8">
          <h1 className="text-[64px] font-bold text-white mb-4">404</h1>
          <h2 className="text-[32px] text-white mb-4">Page Not Found</h2>
          <p className="text-[18px] text-gray-300 mb-8 max-w-md">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>
      </div>
    </MainLayout>
  );
}
